// src/components/Turmas/MoverAlunoModal.js
import React, { useState } from "react";
import styles from "./Turmas.module.css";

const MoverAlunoModal = ({ aluno, turmasExistentes, onMover, onFechar }) => {
  const [novaTurma, setNovaTurma] = useState("");

  const handleConfirmar = () => {
    if (!novaTurma) {
      alert("Selecione uma turma de destino.");
      return;
    }
    onMover(aluno, novaTurma);
  };

  return (
    <div className={styles.modal}>
      <h2>Mover Aluno</h2>
      <p><strong>{aluno?.nome_completo}</strong></p>
      <p>Turma atual: <strong>{aluno?.turma || "Sem Turma"}</strong></p>

      <label>
        Nova Turma:
        <select value={novaTurma} onChange={(e) => setNovaTurma(e.target.value)}>
          <option value="">Selecione...</option>
          {turmasExistentes.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </label>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
        <button onClick={handleConfirmar} className={styles.filterBtn}>
          Confirmar
        </button>
        <button onClick={onFechar} className={styles.exportBtn}>
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default MoverAlunoModal;
